/* Product page conversion layer (2026-10-02). Drives Dawn's hidden variant selects. */
(function () {
  var root = document.querySelector('[data-plxp]');
  var json = document.querySelector('[data-plxp-json]');
  if (!root || !json) return;
  var data;
  try { data = JSON.parse(json.textContent); } catch (e) { return; }
  var section = root.closest('section') || document;
  var variants = data.variants;
  var names = data.options || [];
  var cur = (variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0]);
  var opts = cur.o.slice();
  var SHOW = 12;
  var expanded = {};

  function money(p) {
    return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function dims(s) {
    var m = String(s || '').match(/(\d+(?:\.\d+)?)\s*m?\s*[x×]\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { a: Math.max(a, b), b: Math.min(a, b), area: a * b };
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function valuesFor(i) {
    var seen = [], out = [];
    variants.forEach(function (v) { if (seen.indexOf(v.o[i]) < 0) { seen.push(v.o[i]); out.push(v.o[i]); } });
    return out;
  }
  function match(o) {
    return variants.filter(function (v) { return v.o.every(function (x, k) { return x === o[k]; }); })[0];
  }

  // Which option is the size, if any? (most values parse as W x L)
  var sizeIdx = -1;
  names.forEach(function (n, i) {
    var vals = valuesFor(i);
    var parsed = vals.filter(dims).length;
    if (sizeIdx < 0 && vals.length > 1 && parsed / vals.length >= 0.6) sizeIdx = i;
  });

  var single = variants.length === 1 && /default title/i.test(variants[0].o.join(''));
  if (single) { root.hidden = true; }

  function nativeSelects() {
    return section.querySelectorAll('variant-selects select');
  }

  function choose(i, val) {
    var want = opts.slice();
    want[i] = val;
    var v = match(want);
    if (!v || !v.a) {
      v = variants.filter(function (x) { return x.o[i] === val && x.a; })[0] || v || variants.filter(function (x) { return x.o[i] === val; })[0];
    }
    if (!v) return;
    opts = v.o.slice();
    cur = v;
    paint();
    var sels = nativeSelects();
    var changed = null;
    sels.forEach(function (s, k) {
      if (opts[k] !== undefined && s.value !== opts[k]) { s.value = opts[k]; changed = s; }
    });
    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function paintOptions() {
    var box = root.querySelector('[data-opts]');
    if (single) { box.innerHTML = ''; return; }
    var html = '';
    names.forEach(function (name, i) {
      var vals = valuesFor(i);
      if (vals.length < 2) return;
      var isSize = i === sizeIdx;
      if (isSize) {
        vals = vals.slice().sort(function (x, y) {
          var a = dims(x), b = dims(y);
          if (!a || !b) return 0;
          return a.area - b.area || a.a - b.a;
        });
      }
      var many = isSize && vals.length > SHOW && !expanded[i];
      var shown = vals;
      if (many) {
        shown = vals.slice(0, SHOW);
        if (shown.indexOf(opts[i]) < 0) shown[SHOW - 1] = opts[i];
      }
      html += '<fieldset class="plxp-opt' + (isSize ? ' plxp-opt--size' : '') + '"><legend><span>' + esc(name) + ':</span> <b>' + esc(opts[i]) + '</b>' +
        (isSize ? '<em>' + vals.length + ' sizes</em>' : '') + '</legend><div class="plxp-opt__grid">';
      shown.forEach(function (val) {
        var o = opts.slice(); o[i] = val;
        var v = match(o);
        var any = variants.some(function (x) { return x.o[i] === val && x.a; });
        var off = !(v ? v.a : any);
        var sub = '';
        if (isSize && v) sub = '<small>' + money(v.p) + '</small>';
        if (!isSize && v && cur && v.id !== cur.id) {
          var d = v.p - cur.p;
          if (d !== 0) sub = '<small>' + (d > 0 ? '+' : '−') + money(Math.abs(d)) + '</small>';
        }
        html += '<button type="button" class="plxp-pill' + (val === opts[i] ? ' is-on' : '') + (off ? ' is-off' : '') + '" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (val === opts[i]) + '">' +
          '<span>' + esc(val).replace(/\s*x\s*/i, ' × ') + '</span>' + sub + '</button>';
      });
      html += '</div>';
      if (isSize && vals.length > SHOW) {
        html += '<button type="button" class="plxp-more" data-more="' + i + '">' + (expanded[i] ? 'Show fewer sizes' : 'Show all ' + vals.length + ' sizes') + '</button>';
      }
      html += '</fieldset>';
    });
    box.innerHTML = html;
  }

  function paintPrice() {
    var price = section.querySelector('[id^="price-"]');
    if (!price) return;
    var line = section.querySelector('[data-plxp-save]');
    if (!line) {
      line = document.createElement('div');
      line.className = 'plxp-save';
      line.setAttribute('data-plxp-save', '');
      price.insertAdjacentElement('afterend', line);
    }
    var bits = [];
    if (cur.c > cur.p) {
      var save = cur.c - cur.p;
      bits.push('<span class="plxp-save__pill">You save ' + money(save) + ' (' + Math.round(save * 100 / cur.c) + '%)</span>');
    }
    if (sizeIdx >= 0) {
      var d = dims(opts[sizeIdx]);
      if (d) bits.push('<span class="plxp-save__unit">' + money(cur.p / d.area) + ' per m² · ' + (Math.round(d.area * 100) / 100) + ' m²</span>');
    }
    line.innerHTML = bits.join('');
    line.hidden = !bits.length;
  }

  function mainBtn() { return section.querySelector('.product-form__submit'); }

  var bar = document.querySelector('[data-plxp-bar]');
  function paintBar() {
    if (!bar) return;
    bar.querySelector('[data-bar-variant]').textContent = single ? '' : opts.join(' / ');
    bar.querySelector('[data-bar-price]').innerHTML = (cur.c > cur.p ? '<s>' + money(cur.c) + '</s>' : '') + '<b>' + money(cur.p) + '</b>';
    var b = bar.querySelector('[data-bar-btn]');
    b.disabled = !cur.a;
    b.textContent = cur.a ? 'Add to cart' : 'Sold out';
  }

  function paint() { paintOptions(); paintPrice(); paintBar(); }

  root.addEventListener('click', function (e) {
    var pill = e.target.closest('.plxp-pill');
    if (pill) { choose(+pill.getAttribute('data-i'), pill.getAttribute('data-v')); return; }
    var more = e.target.closest('[data-more]');
    if (more) { var i = +more.getAttribute('data-more'); expanded[i] = !expanded[i]; paintOptions(); }
  });

  // Keep in step with Dawn when it finishes a variant change.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        var mine = variants.filter(function (x) { return x.id === v.id; })[0];
        if (mine) { cur = mine; opts = mine.o.slice(); paint(); }
      });
    }
  } catch (e) {}

  // Size finder
  var finder = root.querySelector('[data-finder]');
  if (finder && sizeIdx >= 0 && /liner|underlay|membrane/i.test(document.title + ' ' + (names[sizeIdx] || ''))) {
    finder.hidden = false;
    var out = finder.querySelector('[data-fout]');
    finder.querySelector('[data-fgo]').addEventListener('click', function () {
      var L = parseFloat(finder.querySelector('[data-fl]').value);
      var W = parseFloat(finder.querySelector('[data-fw]').value);
      var D = parseFloat(finder.querySelector('[data-fd]').value);
      var O = parseFloat(finder.querySelector('[data-fo]').value);
      if (!(L > 0 && W > 0 && D > 0)) { out.innerHTML = '<p class="plxp-finder__err">Enter the length, width and depth in metres.</p>'; return; }
      var A = Math.max(L, W) + 2 * D + 2 * O, B = Math.min(L, W) + 2 * D + 2 * O;
      var best = null;
      valuesFor(sizeIdx).forEach(function (val) {
        var d = dims(val);
        if (!d || d.a + 1e-6 < A || d.b + 1e-6 < B) return;
        var o = opts.slice(); o[sizeIdx] = val;
        var v = match(o) || variants.filter(function (x) { return x.o[sizeIdx] === val; })[0];
        if (!v || !v.a) return;
        if (!best || v.p < best.v.p || (v.p === best.v.p && d.area < best.d.area)) best = { val: val, v: v, d: d };
      });
      var need = '<p class="plxp-finder__need">You need at least <b>' + A.toFixed(2).replace(/\.?0+$/, '') + 'm × ' + B.toFixed(2).replace(/\.?0+$/, '') + 'm</b></p>';
      if (!best) {
        out.innerHTML = need + '<p class="plxp-finder__msg">That is larger than the sizes listed for this liner. Call <a href="tel:+441282270214">01282 270214</a> or <a href="https://wa.me/447822012977" target="_blank" rel="noopener">WhatsApp us</a> your measurements.</p>';
        return;
      }
      out.innerHTML = need + '<div class="plxp-finder__pick"><span>Best fit: <b>' + esc(best.val) + '</b> · ' + money(best.v.p) + '</span><button type="button" data-fpick>Select this size</button></div>';
      out.querySelector('[data-fpick]').addEventListener('click', function () {
        choose(sizeIdx, best.val);
        finder.open = false;
        var g = root.querySelector('.plxp-opt--size');
        if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  // Sticky add-to-cart bar
  if (bar) {
    document.body.appendChild(bar);
    bar.querySelector('[data-bar-btn]').addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) b.click();
    });
    var ticking = false;
    var check = function () {
      ticking = false;
      var btn = mainBtn();
      if (!btn) return;
      var show = btn.getBoundingClientRect().bottom < 0;
      if (show === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('plxp-bar-on', show);
    };
    var onScroll = function () { if (!ticking) { ticking = true; setTimeout(check, 60); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  // Long descriptions: collapse with a "read more" toggle
  var desc = section.querySelector('.product__description');
  if (desc && desc.scrollHeight > 640) {
    desc.classList.add('plxp-desc', 'is-collapsed');
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'plxp-desc__toggle';
    t.textContent = 'Read full description';
    desc.insertAdjacentElement('afterend', t);
    t.addEventListener('click', function () {
      var c = desc.classList.toggle('is-collapsed');
      t.textContent = c ? 'Read full description' : 'Show less';
      if (c) desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  document.documentElement.classList.add('plxp-on');
  paint();
})();
